export const LevelUpModal = ({ show, level, onClose }) => (
  <div
    onClick={onClose}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10001,
      opacity: show ? 1 : 0,
      pointerEvents: show ? 'auto' : 'none',
      transition: 'opacity 0.3s ease'
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '6rem', marginBottom: '20px' }}>🏆</div>
      <div style={{
        fontFamily: "'Orbitron', monospace",
        fontSize: '3rem',
        fontWeight: '900',
        background: 'linear-gradient(135deg, #ffff00, #ff6600)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        marginBottom: '10px'
      }}>
        LEVEL UP!
      </div>
      <div style={{
        fontFamily: "'Orbitron', monospace",
        fontSize: '5rem',
        fontWeight: '900',
        color: '#00f5ff',
        textShadow: '0 0 30px #00f5ff'
      }}>
        {level}
      </div>
    </div>
  </div>
);
